import { Component, ElementRef, Input, OnChanges, OnDestroy, OnInit, QueryList, SimpleChanges, ViewChild, ViewChildren } from '@angular/core';
import {
  Convenio, ConvenioPrestacao, DateFormatPipe, Empenho, FuncaoService, GlobalService, Login
} from 'eddydata-lib';
import { ConfirmationService, MessageService } from 'primeng/api';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { PagamentoService } from '../../../tesouraria/pagamento/service/pagamento.service';
import { ConvenioPrestacaoService } from '../service/convenio-prestacao.service';

declare var $: any;

@Component({
  selector: 'lib-convenio-prestacao',
  templateUrl: './convenio-prestacao.component.html'
})
export class ConvenioPrestacaoComponent implements OnInit, OnChanges, OnDestroy {

  public ptBR: any;
  public titulo: string;
  public tipo: string;
  public entity: ConvenioPrestacao;
  public entityTemp: ConvenioPrestacao;
  public empenho: Empenho;
  public listaPrest: Array<ConvenioPrestacao>;
  protected unsubscribe: Subject<void> = new Subject();
  public listaTipos: { id: string, nome: string }[];

  @Input() lista: Array<any>;
  @Input() entidade: Convenio;
  @Input() login: Login;

  @ViewChild('btnAdicionar') public btnAdicionar: ElementRef;
  @ViewChildren('btnsEditar') public btnsEditar: QueryList<ElementRef>;

  imaskConfig = {
    mask: Number,
    scale: 2,
    thousandsSeparator: '.',
    padFractionalZeros: true,
    normalizeZeros: true,
    radix: ','
  };

  constructor(
    private messageService: MessageService,
    protected confirmationService: ConfirmationService,
    protected globalService: GlobalService,
    public funcaoService: FuncaoService,
    protected pagamentoService: PagamentoService,
    protected prestacaoService: ConvenioPrestacaoService,
  ) { }

  ngOnInit() {
    this.ptBR = this.globalService.obterDataBR();
    this.listaPrest = this.lista;
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.lista) {
      this.listaPrest = this.lista;
      this.titulo = this.entidade.tipo_fornecedor === 'F' ? 'PAGAMENTOS' : 'RECEBIMENTOS';
      this.tipo = this.entidade.tipo_fornecedor;
    }
  }

  private desabilitarEdicao(desabilitar: boolean) {
    this.btnsEditar.forEach((btn) => btn.nativeElement.disabled = desabilitar)
    this.btnAdicionar.nativeElement.disabled = desabilitar;
  }

  public adicionar() {
    this.entity = new ConvenioPrestacao();
    this.entity.data_prestacao = new Date();
    this.entity.convenio = this.entidade;
    this.entity.usuario = this.login.usuario;
    this.entity.exercicio = this.login.exercicio;
    this.entity.valor_quitacao = 0;
    this.entity.editavel = true;
    this.entity['salvo'] = false;
    if (this.entidade.tipo_fornecedor === 'C') {
      this.entity.numero = 0;
    }
    if (!this.listaPrest) {
      this.listaPrest = new Array();
    }
    this.listaPrest.unshift(this.entity);
    this.desabilitarEdicao(true);
  }

  public salvar(item: ConvenioPrestacao) {
    try {
      if (!item.data_prestacao) {
        throw new Error('Informe a data de previsão!');
      }
      item.ano = item.data_prestacao.getFullYear();
      // envia a entidade para ser salva no banco -----
      item.editavel = false;
      item['salvo'] = true;
      this.desabilitarEdicao(false);
    } catch (e) {
      this.messageService.add({ severity: 'error', summary: 'Validação', detail: e });
      throw e;
    }
  }

  public editar(item: ConvenioPrestacao) {
    this.entityTemp = JSON.parse(JSON.stringify(item));

    this.entity = item;
    this.entity.editavel = true;
    this.entity['salvo'] = true;
    this.desabilitarEdicao(true);
    item.data_prestacao = new DateFormatPipe().transform(item.data_prestacao, []);
    item.data_quitacao = new DateFormatPipe().transform(item.data_quitacao, []);
    item.data_contabilizacao = new DateFormatPipe().transform(item.data_contabilizacao, []);
  }

  public cancelar(item: ConvenioPrestacao, index: number) {
    if (item['salvo'] && item.id === this.entityTemp?.id) {
      item.data_prestacao = this.entityTemp.data_prestacao;
      item.valor_prestacao = this.entityTemp.valor_prestacao;
      item.numero = this.entityTemp.numero;
      item.parcela = this.entityTemp.parcela;
      item.data_quitacao = this.entityTemp.data_quitacao;
      item.valor_quitacao = this.entityTemp.valor_quitacao;
      item.data_contabilizacao = this.entityTemp.data_contabilizacao;

      this.entity = item;
      this.entity.editavel = false;
    } else {
      this.listaPrest.splice(index, 1);
    }
    this.desabilitarEdicao(false);
  }

  public confirmarRemocao(item: ConvenioPrestacao, index: number) {
    this.confirmationService.confirm({
      message: 'Tem certeza que deseja remover item?',
      acceptLabel: "Sim",
      rejectLabel: "Não",
      header: 'Remoção',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.remover(item, index)
      },
    });
  }

  private remover(item: ConvenioPrestacao, index: number) {
    if (item.id) {
      this.prestacaoService.remover(item.id).pipe(takeUntil(this.unsubscribe))
        .subscribe((res) => {
          this.listaPrest.splice(index, 1);
          this.messageService.add({ severity: 'info', summary: 'Exclusão', detail: 'Registro removido com sucesso!' });
        }, error => {
          this.messageService.add({ severity: 'error', summary: 'Validação', detail: error.error.payload });
          this.prestacaoService.filtrar(0, -1, {
            'convenio.id': this.entidade.id,
            relations: 'exercicio,pagamento,pagamento.liquidacao,pagamento.liquidacao.empenho,pagamento.liquidacao.empenho.exercicio,recebimento,recebimento.ficha,recebimento.ficha.receita'
          }).pipe(takeUntil(this.unsubscribe))
            .subscribe(
              (data: any) => {
                this.listaPrest = data ? data.content : new Array<ConvenioPrestacao>();
              }, err => this.messageService.add({ severity: 'error', summary: 'Atenção', detail: err.error.payload }));
        });
    } else {
      this.listaPrest.splice(index, 1);
    }
  }

  public async buscarEmpenho() {
    if (this.entity && this.entity.numero) {
      const param = {};
      param['liquidacao.empenho.numero'] = this.entity.numero;
      param['liquidacao.parcela'] = this.entity.parcela;
      param['exercicio.id'] = this.login.exercicio.id;
      param['orgao.id'] = this.login.orgao.id;
      param['relations'] =
        'liquidacao,liquidacao.empenho,liquidacao.empenho.favorecido,exercicio,orgao,liquidacao.empenho.convenio,liquidacao.empenho.exercicio';

      this.entity.pagamento = await this.pagamentoService.obter(param).pipe(takeUntil(this.unsubscribe)).toPromise();
      if (this.entity.pagamento) {
        this.entity.valor_prestacao = this.entity.pagamento.valor_pago;
        this.entity.valor_quitacao = this.entity.pagamento.valor_pago;
        this.entity.data_quitacao = new DateFormatPipe().transform(this.entity.pagamento.data_pagamento, []);
        this.entity.parcela = this.entity.pagamento.liquidacao.parcela;
        this.entity.ano = this.entity.pagamento.exercicio.ano
      }
    }
  }

  public importar() {
    $('#dialogPrestacao').modal('show');
  }


  public callbackPrestacao(lista: []) {
    this.listaPrest = lista;
  }

}
